var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    rx: 2,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0H10C11.1046 0 12 0.89543 12 2V10C12 11.1046 11.1046 12 10 12H2C0.89543 12 0 11.1046 0 10V2C0 0.89543 0.89543 0 2 0ZM3.38241 5.06892C3.50441 5.12133 3.61475 5.19751 3.707 5.29302L5 6.58602L8.293 3.29302C8.38525 3.19751 8.49559 3.12133 8.6176 3.06892C8.7396 3.01651 8.87082 2.98892 9.0036 2.98777C9.13638 2.98662 9.26806 3.01192 9.39095 3.0622C9.51385 3.11248 9.6255 3.18673 9.7194 3.28063C9.81329 3.37452 9.88754 3.48617 9.93782 3.60907C9.9881 3.73196 10.0134 3.86364 10.0123 3.99642C10.0111 4.1292 9.98351 4.26042 9.9311 4.38242C9.87869 4.50443 9.80251 4.61477 9.707 4.70702L5.707 8.70702C5.51947 8.89449 5.26517 8.99981 5 8.99981C4.73484 8.99981 4.48053 8.89449 4.293 8.70702L2.293 6.70702C2.19749 6.61477 2.12131 6.50443 2.0689 6.38242C2.01649 6.26042 1.9889 6.1292 1.98775 5.99642C1.9866 5.86364 2.0119 5.73196 2.06218 5.60907C2.11246 5.48617 2.18671 5.37452 2.28061 5.28063C2.3745 5.18673 2.48615 5.11248 2.60905 5.0622C2.73194 5.01192 2.86362 4.98662 2.9964 4.98777C3.12918 4.98892 3.2604 5.01651 3.38241 5.06892Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.8dab88046730f818db6c9ce4f4086455.svg";
export { ForwardRef as ReactComponent };